import { render, staticRenderFns } from "./breadcrumbRedesign.vue?vue&type=template&id=4cfe484a"
import script from "./breadcrumbRedesign.vue?vue&type=script&lang=js"
export * from "./breadcrumbRedesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports